export enum ToastType {
    error = 'error',
    success = 'success',
    info = 'info',
}
